
import apiClient from "./api";

export const getUserBalance = async () => {
  try {
    const response = await apiClient.get("/wallet/get-userbalance");
    return response.data;
  } catch (error) {
    console.error("Fetch balance error:", error);
    throw error.response?.data || { message: "Failed to fetch balance" };
  }
};

export const topUpWallet = async (topUpData) => {
  try {
    // Add a longer timeout for the API call (60 seconds)
    const response = await apiClient.post("/wallet/topup", topUpData, {
      timeout: 60000, // 60 seconds timeout
    });
    return response.data;
  } catch (error) {
    console.error("Top-up error:", error);

    // Check if it's a timeout error
    if (error.code === "ECONNABORTED") {
      throw new Error("Payment request timeout. Please try again.");
    }

    // Get the actual backend error message if available
    const backendMessage = error.response?.data?.message;
    const backendError = error.response?.data?.error;

    // Create a proper Error object with the backend message
    const errorMessage =
      backendMessage || backendError || "Failed to process top-up";
    throw new Error(errorMessage);
  }
};

export const getTransactionHistory = async () => {
  try {
    const response = await apiClient.get("/wallet/transactions");
    return response.data;
  } catch (error) {
    console.error("Fetch transactions error:", error);
    throw error.response?.data || { message: "Failed to fetch transactions" };
  }
};

export const getWalletStatement = async () => {
  try {
    const response = await apiClient.get("/wallet/statement");
    return response.data;
  } catch (error) {
    console.error("Fetch wallet statement error:", error);
    throw (
      error.response?.data || { message: "Failed to fetch wallet statement" }
    );
  }
};
